/**
 * Activity List widget constants.
 * Activity types map to Figma IconHighlight variants.
 * Figma icon bg: #e5f8ff (surface/light-blue). @ann/web-components LightBlue/primary/Alert map to theme.
 */
export const ACTIVITY_TYPE_CONFIG = Object.freeze({
  call: {
    icon: 'call',
    bgColor: 'primary',
    iconColor: 'primary',
  },
  email: {
    icon: 'email',
    bgColor: 'LightBlue',
    iconColor: 'LightBlue',
  },
  sms: {
    icon: 'sms',
    bgColor: 'Alert',
    iconColor: 'Alert',
  },
});

/** Alert types for critical states (WID-04) */
export const ALERT_TYPES = Object.freeze({
  NEEDS_ATTENTION: 'needs_attention',
  EXPIRED: 'expired',
});

/** Width threshold: layout w <= this shows compressed variant */
export const COMPRESSED_LAYOUT_W_THRESHOLD = 4;

export const ACTIVITY_CARD_MAX_CHARACTERS = 80;

export const METADATA_ICONS = Object.freeze({
  sentiment: 'sentiment_satisfied',
  assignedTasks: 'check_box',
  hasRecording: 'graphic_eq',
  hasExternalLink: 'arrow_outward',
  duration: 'schedule',
  direction: 'call_end',
  flagged: 'flag',
  comments: 'chat_bubble',
  attachments: 'attach_file',
  link: 'link',
});


export const METADATA_BAR_CONFIG = Object.freeze({
  call: ['userId', 'sentiment', 'assignedTasks', 'hasRecording', 'hasExternalLink', 'duration', 'direction', 'flagged'],
  email: ['userId', 'commentsCount', 'attachmentsCount', 'assignedTasks', 'hasExternalLink', 'flagged'],
  sms: ['userId', 'commentsCount', 'attachmentsCount', 'assignedTasks', 'hasExternalLink', 'linkCount', 'flagged'],
});

export { ACTIVITY_STATE_COPY } from '../../../../constants';
